import { MessageSquareQuote, ArrowRight } from "lucide-react";
export const InterviewsSection = () => (
  <section id="bulk-interviews" className="recruit-interviews recruit-section">
    <div className="recruit-shell recruit-feature-grid">
      <div>
        <p className="recruit-eyebrow">03 / Ask the next question</p>
        <h2>
          More depth.
          <br />
          <span>Less calendar coordination.</span>
        </h2>
        <p className="recruit-feature-body">
          Send role-specific AI interview invitations to selected candidates. When they complete the
          interview, review their responses and transcripts in your hiring workflow.
        </p>
        <a href="/demo" className="recruit-text-link">
          Explore interview demos <ArrowRight size={16} />
        </a>
      </div>
      <div className="recruit-interview-board">
        <div className="recruit-board-label">
          <MessageSquareQuote size={18} />
          <span>Role-specific AI screening</span>
        </div>
        <ol>
          <li>
            <span>01</span>
            <div>
              <strong>You set the direction.</strong>
              <p>Choose the role, questions, and candidates.</p>
            </div>
          </li>
          <li>
            <span>02</span>
            <div>
              <strong>The candidate has a conversation.</strong>
              <p>The AI conducts the interview and captures responses.</p>
            </div>
          </li>
          <li>
            <span>03</span>
            <div>
              <strong>Your team reviews the substance.</strong>
              <p>Return to the completed interview and its transcript.</p>
            </div>
          </li>
        </ol>
        <div className="recruit-board-footer">
          Recruiter-requested interviews. Human hiring decisions.
        </div>
      </div>
    </div>
  </section>
);
